import { SessionStorageEngine } from './session-storage.interface';
import { SessionStorage } from 'devere-capacitor-session-storage';

/**
 * Browser mobile provider
 */
export class SessionStorageNativeEngine implements SessionStorageEngine
{
    //#region Constructor

    /**
     * Class constructor
     */
    constructor()
    {
    }

    //#endregion


    //#region Methods

    /**
    * Get value in index
    * @param {string} key identifier for data to get
    */
    public async getValue(key: string): Promise<any>
    {
        let result = await SessionStorage.getValue({ key: key });
        return Promise.resolve(result.value);
    }

    /**
     * Set value of index location
     * @param {string} key identifier for data to set
     * @param {any} value value to asign in index location
     */
    public async setValue(key: string, value: any)
    {
        await SessionStorage.setValue({ key: key, value: value });
    }

    /**
     * Clears session data
     */
    public async clearSessionStorage()
    {
        await SessionStorage.clearSessionStorage();
    }

    //#endregion

}